import { styled } from '@ori-ui/mui';
import { shouldForwardProp } from '@ori/presentation-utils';

import {
  CSS_DESKTOP_INNER_HEIGHT,
  CSS_HEIGHT_ANIMATION,
  CSS_MOBILE_INNER_HEIGHT,
  TOP_AREA_BORDER_BOTTOM,
} from '../../constants';
import { TOP_AREA_BANNER_HEIGHT } from '../TopAreaBanner';

interface RootProps {
  isSearchInputVisible?: boolean;
  isTopBannerVisible?: boolean;
}

export const Root = styled('nav', {
  shouldForwardProp: shouldForwardProp(),
})<RootProps>(({ theme, isSearchInputVisible, isTopBannerVisible }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderBottom: `${TOP_AREA_BORDER_BOTTOM}px solid ${isSearchInputVisible ? theme.palette.common.white : theme.palette.grey[100]}`,
  boxSizing: 'border-box',
  display: 'flex',
  height: CSS_MOBILE_INNER_HEIGHT,
  left: 0,
  padding: theme.spacing(0, 3),
  position: 'fixed',
  top: isTopBannerVisible ? TOP_AREA_BANNER_HEIGHT : 0,
  transition: `height ${CSS_HEIGHT_ANIMATION}, background-color 0.1s ease-in-out`,
  width: '100vw',
  zIndex: theme.zIndex.appBar,

  [theme.breakpoints.up('md')]: {
    borderBottom: `${TOP_AREA_BORDER_BOTTOM}px solid ${theme.palette.grey[100]}`,
    height: CSS_DESKTOP_INNER_HEIGHT,
    padding: theme.spacing(0, 9, 0, 6),
  },

  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(0, 11, 0, 8),
  },

  [theme.breakpoints.up('xl')]: {
    padding: theme.spacing(0, 15, 0, 12),
  },
}));
